/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.26",
    versionName: "0.3.0-nightly.2026.5.26",
    versionChannel: "nightly",
    buildDate: "2026-05-26T00:33:21.353Z",
    commitHash: "89b2fa4555601b3bf0108f0d8abccc19850f8161",
};
